export class Menu {
    constructor(public id: number,
                public title: string,
                public routerLink: string,
                public href: string,
                public icon: any,
                public target: string,
                public hasSubMenu: boolean,
                public parentId: number,
                public id_menu: string) { }
} 